/**
 * Haptic feedback via navigator.vibrate. Gated por capability — em desktops
 * ou navegadores sem suporte é um no-op silencioso. A API também pode estar
 * desativada pelo usuário (iOS Safari ignora chamadas fora de gesto direto).
 */
export function vibrate(ms: number | number[]): void {
  if (typeof navigator === 'undefined') return;
  const vib = (navigator as Navigator & { vibrate?: (pattern: number | number[]) => boolean })
    .vibrate;
  if (typeof vib !== 'function') return;
  try {
    vib.call(navigator, ms as number & number[]);
  } catch {
    // noop
  }
}
